import React from 'react'
import Accordion, { AccordionItem } from '@ublique/components/Accordion'
import { isEmpty } from 'lodash'

export const formatUserPreferencesData = ({
  userPrefMasterData,
  wtId,
  labelMap,
  modelInfoT: t
}) => {
  const {
    hiddenColumns = {},
    lockedColumns = {},
    filteredColumns = {}
  } = userPrefMasterData

  const sectionsConfig = [
    {
      id: 'hidden',
      title: t('UserPreferences.HIDDEN_COLUMNS_SECTION'),
      data: hiddenColumns[wtId] ?? []
    },
    {
      id: 'locked',
      title: t('UserPreferences.LOCKED_COLUMNS_SECTION'),
      data: lockedColumns[wtId] ?? []
    },
    {
      id: 'savedfilters',
      title: t('UserPreferences.SAVED_FILTERS_SECTION'),
      data: filteredColumns[wtId]?.map(({ name }) => name) ?? []
    }
  ]

  return (
    <div className='model-info-userpref-content'>
      <Accordion>
        {sectionsConfig.map((config) => renderSection(config, labelMap, t))}
      </Accordion>
    </div>
  )
}

const renderSection = ({ id, title, data }, labelMap, t) => {
  if (id === 'savedfilters') {
    return (
      <AccordionItem key={id} title={title}>
        {isEmpty(data)
          ? renderSectionElement({
              key: 'none',
              field: 'none',
              fieldLabel: t('UserPreferences.NO_FILTERS')
            })
          : data.map((field, idx) => {
              return renderSectionElement({
                key: idx,
                field,
                fieldLabel: field
              })
            })}
      </AccordionItem>
    )
  }

  return (
    <AccordionItem key={id} title={title}>
      {isEmpty(data)
        ? renderSectionElement({
            key: 'none',
            field: 'none',
            fieldLabel: t('UserPreferences.NO_COLUMNS')
          })
        : data.map((field, idx) => {
            return renderSectionElement({
              key: idx,
              field,
              fieldLabel: labelMap[field] ?? field
            })
          })}
    </AccordionItem>
  )
}

const renderSectionElement = ({ key, field, fieldLabel }) => {
  return (
    <div className='model-info-userpref-field' key={key}>
      <span className='model-info-userpref-field-text' key={field}>
        {fieldLabel}
      </span>
    </div>
  )
}
